import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from 'src/app/core/utils.service';
import { DetailVopRequest, VopRequest, VopRequestMostSimilarCall } from 'src/app/core/vop-request.service';

@Component({
  selector: 'app-vop-request-detail-dialog',
  templateUrl: './vop-request-detail-dialog.component.html',
  styleUrls: ['./vop-request-detail-dialog.component.scss'],
})
export class VopRequestDetailDialogComponent {
  vop_calls?: DetailVopRequest[];

  constructor(
    private dialog_ref: MatDialogRef<VopRequestDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private utils_service: UtilsService,
  ) {
    this.vop_calls = data.vop_calls;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  getVopRequestMostSimilarCallLabel(type: String): string {
    if (!type) return '';
    return this.utils_service.getVopRequestMostSimilarCallLabel(type as VopRequestMostSimilarCall);
  }
}
